
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MenuItem } from 'material-ui';
import SentIcon from 'material-ui/svg-icons/content/send';
import { SEND_TOURWRITER } from '../__storeFiles__/constants';

class ExportTourWriter extends Component {
  render() {
    const {
      contractId,
      tourWriter,
      sendTourWriter,
      blackout,
    } = this.props;
    if (!tourWriter) return <div/>;
    const caption = blackout ? 'Tourwriter Export (Excludes Blackouts)' : 'Tourwriter Export';
    return (
      <MenuItem
        style={{ fontSize: '15px', minHeight: '32px', lineHeight: '32px' }}
        innerDivStyle={{ padding: '0px 24px 0px 64px' }}
        leftIcon={(
          <SentIcon
            color="rgba(0, 0, 0, 0.84)"
            style={{
              top: '4px',
              margin: '0',
              left: '24px',
              fill: 'rgb(117, 117, 117)',
            }}
          />
        )}
        primaryText={caption}
        onTouchTap={() => {
          sendTourWriter({ contractId, blackout });
        }}
      />
    );
  }
}
ExportTourWriter.defaultProps = {
  contractId: undefined,
  tourWriter: false,
  sendTourWriter: () => {},
  blackout: false,
};

ExportTourWriter.propTypes = {
  contractId: PropTypes.string,
  tourWriter: PropTypes.bool,
  sendTourWriter: PropTypes.func,
  blackout: PropTypes.bool,
};

const mapStateToProps = ({ user }) => ({
  tourWriter: user.getIn(['company', 'tourWriter']),
});

export default connect(mapStateToProps, {
  sendTourWriter: payload => ({ type: SEND_TOURWRITER, payload }),
})(ExportTourWriter);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/exportTourWriter.jsx